import Keycloak from 'keycloak-js';

const url = process.env.REACT_APP_KC_DOMAIN;
const realm = process.env.REACT_APP_KC_REALM;
const clientId = process.env.REACT_APP_KC_CLI;

export default new Keycloak({ url, realm, clientId });
